/*
 * action types
 */

export const SET_SEARCH_TEXT = "action.set.search.text";
export const SET_SEARCH_RESULTS = "action.set.search.results";
export const SET_FIREBASE = "action.set.firebase";
export const SET_GOOGLE = "action.set.google";
export const SET_USER = "action.set.user";


// WEBPACK FOOTER //
// ./src/actions/index.js